import * as Yup from 'yup';

export default Yup.object().shape({
  isDoctorWithTitle: Yup.boolean().required('SCHEMA_ERRORS.ENTER_VALUE'),
  yearsOperating: Yup.number()
    .required('SCHEMA_ERRORS.ENTER_VALUE')
    .min(1, 'SCHEMA_ERRORS.MIN_1_YEAR'),
  tikTok: Yup.string(),
  instagram: Yup.string(),
  facebook: Yup.string(),
  monthlyIncome: Yup.number()
    .positive('SCHEMA_ERRORS.NUMBER_MUST_BE_GREATER_THAN_ZERO')
    .typeError('SCHEMA_ERRORS.NUMBER_REQUIRED')
    .required('SCHEMA_ERRORS.REQUIRED_FIELD')
});
